import { type FunctionComponent, useMemo } from 'react';
import Logo from '../../assets/images/logo.svg?react';
import { type RootState } from '../../core/root.state';
import { useEnvironment } from '../../hooks/useEnvironment';
import { useSelector } from '../../hooks/useSelector';
import { useTranslation } from '../../i18n/resources';
import { ChannelList } from '../ChannelList/ChannelList';
import styles from './Sidebar.module.css';
import { SidebarMenu } from './SidebarMenu/SidebarMenu';

export type SidebarProps = {};

export const Sidebar: FunctionComponent<SidebarProps> = () => {
  const { t } = useTranslation();
  const environment = useEnvironment();
  const showPairingAndSharing =
    environment.VITE_APP_PRAYER_STREAM_PAIRING_AND_SHARING_ENABLED;
  const { contactUid } = useSelector((state) => state.auth);
  const memberChannelData = useSelector(
    (state: RootState) => state.stream.communityChannelData,
  );

  const ccmPublicFilters = useMemo(() => {
    return { members: { $in: [contactUid] }, type: 'ccm_public' };
  }, [contactUid]);

  const ccmMemberSharingFilters = useMemo(() => {
    return { members: { $in: [contactUid] }, type: 'ccm_member_sharing' };
  }, [contactUid]);

  const ccmCommunityFilters = useMemo(() => {
    return { members: { $in: [contactUid] }, type: 'ccm_community' };
  }, [contactUid]);

  return (
    <div className={styles.root}>
      <div className={styles.company}>
        <div className={styles.logo}>
          <Logo />
        </div>
        <SidebarMenu memberChannelData={memberChannelData} />
      </div>
      <div className={styles.sidebar}>
        <div className={styles.title}>{t('prayerStream', 'prayer_stream')}</div>
        <div className={styles.channels}>
          <div className={styles.publicChannel}>
            <div className={styles.channelGroupTitle}>
              {t('prayerStream', 'channel_group_member_prayer')}
            </div>
            <div className={styles.channelGroupList}>
              <ChannelList filters={ccmPublicFilters} />
            </div>
          </div>
          {showPairingAndSharing && (
            <div className={styles.channelGroup}>
              <div className={styles.channelGroupTitle}>
                {t('prayerStream', 'share_events')}
              </div>
              <div className={styles.channelGroupList}>
                <ChannelList
                  filters={ccmMemberSharingFilters}
                  type={'ccm_member_sharing'}
                />
              </div>
            </div>
          )}
          <div className={styles.channelGroup}>
            <div className={styles.channelGroupTitle}>
              {t('prayerStream', 'channel_group_community_groups')}
            </div>
            <div className={styles.channelGroupList}>
              <ChannelList
                filters={ccmCommunityFilters}
                type={'ccm_community'}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
